import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
// import styles from './DBDropDown.module.css';


class DBSpecDropDown extends React.Component {

    updateField(event) {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
        if (!event.isPropagationStopped()) {
            if (event.target.value === '-1') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            }
            else {
                this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseInt(event.target.value));
            }
        }
    }

    render() {
        return (
            // TODO: was trying to overlay placeholder text if no value was selected.  This was causing
            // layout issues but the concept was close.
            // <div style={{ height: '1px' }} className={this.props.className}>
            //     {this.props.placeholder && !this.props.value &&
            //         <div className={styles.placeholder}>{this.props.placeholder}</div>
            //     }
            <select
                // style={{ position: 'absolute' }}
                title={this.props.title}
                value={this.props.value !== undefined ? this.props.value : -1}
                name={this.props.field}
                className={this.props.className}
                disabled={this.props.disabled}
                onChange={(event) => this.updateField(event)}
            >
                <option key={-1} value={-1}></option>

                {this.props.myOptions &&
                    Object.keys(this.props.myOptions)
                        .map(id => {
                            const option = this.props.myOptions[id];
                            return (
                                <option key={option.TSDNO} value={option.TSDNO}>{option.TSDNAME}</option>
                            );
                        })
                }
            </select>
            // </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {

    let value = state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined &&
    state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
    state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : -1

    let type = state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].DATA_TYPE


    let myOptions = Object.keys(state.entities.masterData.PTOBJECTIVESPECTESTSGROUPDETAILS)
    .filter(key => state.entities.masterData.PTOBJECTIVESPECTESTSGROUPDETAILS[key].TSDTSGNO === ownprops.optionsValue)
    .sort((a , b) => state.entities.masterData.PTOBJECTIVESPECTESTSGROUPDETAILS[a].TSDORDER - state.entities.masterData.PTOBJECTIVESPECTESTSGROUPDETAILS[b].TSDORDER)
    .map(key => state.entities.masterData.PTOBJECTIVESPECTESTSGROUPDETAILS[key])


    return { 
        value,
        type,
        myOptions
    };
}

const connectedDBSpecDropDown = connect(mapStateToProps, mapDispatchToProps)(DBSpecDropDown);
export { connectedDBSpecDropDown as DBSpecDropDown };